// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sdp5","select":"styles_select__3cl1L"};